import React from 'react';
import T from 'prop-types';

export const TextLink = ({ text, className, onClick }) => {
    return <button className={className} onClick={onClick}><span>{text}</span></button>;
};

TextLink.T = {
    text: T.string,
    className: T.string,
    onClick: T.func
};

TextLink.defaultProps = {
    className: 'textLinkDefault',
};
